module.exports = __webpack_public_path__ + "img/ExpandMore2.0b468d58.svg";